import { defineStore } from 'pinia';

import { getEditorialSections } from '@/shared/api/experience';
import type { Article } from '@/shared/models/journal';
import { normalizeArticle } from '@/shared/stores/journal/transforms';
import { useLogger } from '@/shared/utils/logger';

export interface EditorialSection {
  title: string;
  articles: Article[];
}

export const useEditorialArticlesEntity = defineStore('journal:editorialArticles', {
  state: () => ({
    sectionsState: [] as EditorialSection[],
    isLoading: false,
  }),

  getters: {
    sections: (state) => state.sectionsState,
    loading: (state) => state.isLoading,
    hasSections: (state) => state.sectionsState.length > 0,
  },

  actions: {
    logger: useLogger,

    async getEditorialArticles() {
      this.isLoading = true;

      let data;

      try {
        const response = await getEditorialSections();
        data = response.data;
      } catch (error) {
        this.logger().error(error);
        this.isLoading = false;

        return;
      }

      if (!data || !Array.isArray(data) || data.length === 0) {
        this.isLoading = false;

        return;
      }

      this.sectionsState = data.map((section) => ({
        title: section.title ?? '',
        articles: section.articles_data?.map(normalizeArticle) ?? [],
      }));

      this.isLoading = false;
    },
  },
});
